/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceSimulatedMapper {
  static createModelFromResponse(response) {
    return {
      currency: response.currency,
      showDiscountedPrice: response.show_discounted_price,
      discountedPrice: typeof response.discounted_price === 'number' ? response.discounted_price : undefined
    };
  }
}

export { PriceSimulatedMapper };
//# sourceMappingURL=PriceSimulatedMapper.js.map
